import { render, staticRenderFns } from "./Form18StyleOfProceeding.vue?vue&type=template&id=56e3dc75&scoped=true"
import script from "./Form18StyleOfProceeding.vue?vue&type=script&lang=ts"
export * from "./Form18StyleOfProceeding.vue?vue&type=script&lang=ts"
import style0 from "./Form18StyleOfProceeding.vue?vue&type=style&index=0&id=56e3dc75&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e3dc75",
  null
  
)

export default component.exports